import {
  ManagerProgressionTaskState,
  Sport,
} from '#src/__generated__/globalTypes.ts';
import { useConfigContext } from '#src/contexts/config/index.ts';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';
import { useSportContext } from '#src/contexts/sport/index.ts';
import { useLifecycle } from '#src/hooks/useLifecycle.ts';

export const useUnclaimedMarketTasksCount = () => {
  const { sport } = useSportContext();
  const { currentUser } = useCurrentUserContext();
  const { lifecycle } = useLifecycle();
  const { tasks } = useConfigContext();

  const claimableTasksCount =
    tasks?.filter(t => t.aasmState === ManagerProgressionTaskState.COMPLETED)
      ?.length || 0;

  const isCommonGameOnboarded = () => {
    if (sport === Sport.NBA || sport === Sport.FOOTBALL) {
      return !!currentUser?.anyUserSportProfile?.commonGameOnboarded;
    }
    return false;
  };

  return isCommonGameOnboarded() && !lifecycle?.hideCommonFeatures
    ? claimableTasksCount
    : 0;
};
